module.exports = __webpack_public_path__ + "img/cart.bde6b753.svg";